<template>
  <div class="tab-content">
    <management-tabs-and-search
      :tabs="tabs"
      :open-tab="openTab"
      @update-open-tab="openTab = $event"
    />
    <v-tabs-items :value="openTab">
      <v-tab-item value="Workorder">
        work
      </v-tab-item>
      <v-tab-item value="activities">
        <activities-table @openActivity="ActivityUuid($event)" />
      </v-tab-item>

      <v-tab-item value="details">
        <transition name="slide-fade">
          <component
            :is="activePage.activityDetails"
            :activityUUID="activityUUID"
            @viewTask="viewTask"
            v-show="activityIsActive"
          />
        </transition>

        <transition name="slide-fade">
          <component
            :is="activePage.taskDetails"
            v-if="taskIsActive"
            :task="task"
            :backButton="backButton"
          />
        </transition>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ActivitiesTable from "./ActivitiesTable.vue";
import ActivityView from "./ActivityView.vue";
import TaskDetails from "./TaskDetails.vue";
import ManagementTabsAndSearch from "@/components/_Organisms/ManagementTabsAndSearch";
export default {
  name: "ActivitiesTab",

  components: { ActivitiesTable, ManagementTabsAndSearch, ActivityView },

  data() {
    return {
      activePage: {
        activityDetails: ActivityView,
        taskDetails: TaskDetails
      },
      openTab: "activities",
      task: [],
      activityUUID: undefined,
      activityIsActive: false,
      taskIsActive: false,
      isActive: true
    };
  },

  computed: {
    tabs() {
      let tabs = [
        {
          value: "workorder",
          text: this.$i18n.t("WorkOrder"),
          disabled: true
        },
        {
          value: "activities",
          text: this.$i18n.tc("Activity", 2)
        },
        {
          value: "details",
          text: this.$i18n.tc("Detail", 2),
          disabled: this.isActive
        }
      ];

      return tabs;
    }
  },

  methods: {
    ActivityUuid(value) {
      this.activityUUID = value;
      this.isActive = false;
      this.taskIsActive = false;
      this.activityIsActive = true;
      this.openTab = "details";
    },
    viewTask(task) {
      this.task = task;
      this.activityIsActive = false;
      this.taskIsActive = true;
    },
    backButton() {
      this.taskIsActive = false;
      this.activityIsActive = true;
    }
  }
};
</script>

<style scoped>
.tab-content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
}
.network-tab-tools-container {
  position: absolute;
  top: 0;
  left: 0;
}
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Activities/ActivitiesTab.vue